import { useMySphLightbox } from "@features/mySph/hooks/useMySphLightbox";
import { TABOOLA_SCRIPT } from "@features/taboola/utils/constants";
import useScript from "@hooks/useScript";
import lotameInitScript from "@util/customScripts/lotameInitScript";

import useLink from "./useLink";
import { fetchEnvelope, useLiveRamp } from "./useLiveRamp";
import useScriptFunction from "./useScriptFunction";
import { IS_PLAYWRIGHT } from "../util/constant";

/**
 *  Hook that loads all scripts, links, and custom hooks
 */
export default function useAllCustomHooks() {
  useMySphLightbox();

  useScript({
    id: "google-ads-script",
    src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
    type: "text/javascript",
    checkScriptIsLoaded: () => {
      // Disable loading adtag script if
      // - ran from playwright
      return IS_PLAYWRIGHT;
    },
  });

  useScript({
    id: "google-ads-script",
    src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
    type: "text/javascript",
    checkScriptIsLoaded: () => {
      // Disable loading adtag script if
      // - ran from playwright
      return IS_PLAYWRIGHT;
    },
  });

  useScript({
    id: "edge-permutive-app",
    async: true,
    src: "https://5f876161-9740-4cc8-9b64-4585990b2690.edge.permutive.app/5f876161-9740-4cc8-9b64-4585990b2690-web.js",
    type: "text/javascript",
    checkScriptIsLoaded: () => {
      // Disable loading premutive script if
      // - ran from playwright
      return IS_PLAYWRIGHT;
    },
  });

  // Lotame Tags
  useLink({
    id: "tags-crwdcntrl-preconnect",
    rel: "preconnect",
    href: "https://tags.crwdcntrl.net",
  });

  useLink({
    id: "bcp.crwdcntrl",
    rel: "preconnect",
    href: "https://bcp.crwdcntrl.net",
  });

  useLink({
    id: "tags-crwdcntrl-prefetch",
    rel: "dns-prefetch",
    href: "https://tags.crwdcntrl.net",
  });

  useScript({
    id: "tags-crwdcntrl-script",
    async: true,
    src: "https://tags.crwdcntrl.net/lt/c/12374/lt.min.js",
    type: "text/javascript",
  });

  useScriptFunction({
    id: "lotame-init",
    value: lotameInitScript,
    type: "text/javascript",
  });

  // Set Live Ramp Cookie
  useLiveRamp({ fetchEnvelope });

  useScriptFunction({
    id: "taboola-script",
    value: TABOOLA_SCRIPT,
    type: "text/javascript",
  });
}
